import { render, staticRenderFns } from "./Specific_business.vue?vue&type=template&id=107c5da4&scoped=true&"
import script from "./Specific_business.vue?vue&type=script&lang=js&"
export * from "./Specific_business.vue?vue&type=script&lang=js&"
import style0 from "./Specific_business.vue?vue&type=style&index=0&id=107c5da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c5da4",
  null
  
)

export default component.exports